import ContentsTypes from "@shared/enums/contentsTypes";
import HomeTemplate from "@project/templates/home/HomeTemplate";
import contentsCustomTypesEnum from "@project/enums/contentsCustomTypes.enum";
const createHorizontalInfoItem = (title, subtitle, description) => ({
    key: "items",
    type: contentsCustomTypesEnum.HORIZONTAL_INFO_ITEM,
    value: "",
    children: [
        {
            key: "title",
            label: "Titre",
            type: ContentsTypes.INPUT,
            value: title,
        },
        {
            key: "subtitle",
            label: "Sous-titre",
            type: ContentsTypes.INPUT,
            value: subtitle,
        },
        {
            key: "description",
            label: "Description",
            type: ContentsTypes.INPUT,
            value: description,
        },
        {
            key: "color",
            label: "Couleur",
            type: ContentsTypes.COLOR,
            value: "#0CFFC6",
        },
    ],
});
const createCardGridItem = (title, subtitle, description, link, icon) => ({
    key: "items",
    type: contentsCustomTypesEnum.CARDS_GRID_ITEM,
    value: "",
    children: [
        {
            key: "icon",
            label: "Icône",
            type: ContentsTypes.ICON,
            value: "",
            children: icon
                ? [
                    {
                        key: "icon",
                        type: ContentsTypes.INPUT,
                        value: icon,
                    },
                    {
                        key: "type",
                        type: ContentsTypes.INPUT,
                        value: "far",
                    },
                    {
                        type: ContentsTypes.COLOR,
                        key: "color",
                        value: "#1C1C1E",
                    },
                    {
                        type: ContentsTypes.COLOR,
                        key: "background",
                        value: "#EAF1FF",
                    },
                ]
                : [],
        },
        {
            key: "title",
            label: "Titre",
            type: ContentsTypes.INPUT,
            value: title,
        },
        {
            key: "subtitle",
            label: "Sous-titre",
            type: ContentsTypes.INPUT,
            value: subtitle,
        },
        {
            key: "description",
            label: "Description",
            type: ContentsTypes.INPUT,
            value: description,
        },
        {
            key: "link",
            label: "Lien",
            type: ContentsTypes.LINK,
            value: "",
            children: [
                {
                    key: "url",
                    type: ContentsTypes.URL,
                    value: link?.url || "",
                },
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: link?.title || "",
                },
            ],
        },
    ],
});
const createAutoScrollingInfoItem = (title, imageUrl) => ({
    key: "items",
    type: contentsCustomTypesEnum.AUTO_SCROLLING_INFO_ITEM,
    value: "",
    children: [
        {
            key: "title",
            label: "Titre",
            type: ContentsTypes.INPUT,
            value: title,
        },
        {
            key: "image",
            label: "Image",
            type: ContentsTypes.IMAGE,
            value: "",
            children: [
                {
                    key: "file",
                    type: ContentsTypes.FILE_IMAGE,
                    value: JSON.stringify({
                        url: imageUrl ||
                            "https://as1.ftcdn.net/jpg/05/83/61/64/1000_F_583616420_cyNZmksm5h2x5vgcKGmRjnivfmrgnSTb.jpg",
                    }),
                },
                {
                    key: "alt",
                    type: ContentsTypes.INPUT,
                    value: "",
                },
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: title,
                },
            ],
        },
    ],
});
export default {
    key: "HOME",
    label: "Accueil",
    shortDescription: "Docaposte Agility réunit une équipe de passionnés capables de maîtriser toute la chaîne d’un projet de l’architecture jusqu’à la maintenance.",
    templateImage: "/template-home.png",
    Component: HomeTemplate,
    initialContents: [
        {
            key: "title",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Des experts au service de vos projets numériques ",
        },
        {
            key: "subtitle",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Docaposte Agility filiale de Docaposte",
        },
        {
            key: "presentationDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
        },
        {
            key: "autoScrollingClientsPart",
            type: contentsCustomTypesEnum.AUTO_SCROLLING_INFOS,
            value: "",
            children: [
                {
                    key: "nbRow",
                    type: ContentsTypes.INPUT_NUMBER,
                    value: "1",
                },
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: contentsCustomTypesEnum.AUTO_SCROLLING_INFO_ITEM,
                            children: [
                                createAutoScrollingInfoItem("L'identité Numérique", "https://lidentitenumerique.laposte.fr/build/images/logo.5a322ede.svg"),
                                createAutoScrollingInfoItem("AXA", "https://axa.scene7.com/is/content/axafrance/axa-logo-solid-rgb-1"),
                                createAutoScrollingInfoItem("Airbus", "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Airbus_logo_2017.png/960px-Airbus_logo_2017.png"),
                                createAutoScrollingInfoItem("Caisse des Dépôts", "https://www.caissedesdepots.fr/sites/cdc.fr/files/accueil_CDC.png"),
                                createAutoScrollingInfoItem("Ordre national des pharmaciens", "https://www.ordre.pharmacien.fr/build/images/logo.svg"),
                                createAutoScrollingInfoItem("LA POSTE", "https://www.laposte.fr/ecom/_nuxt/logo-part-horizontal.BtezbiGr.svg"),
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "descriptionEditable",
            type: ContentsTypes.TEXT,
            value: "<p style='text-align: center;'><span style='font-family: Montserrat; font-size: 34px; font-weight: 700; line-height: 1.3;'>" +
                "Nous sommes un collectif d’experts passionnés par les nouvelles technologies, qui " +
                "<span style='color: #0000FF'>co-construit les solutions numériques</span> " +
                "de nos clients et partenaires.</span></p>",
        },
        {
            key: "subDescriptionEditable",
            type: ContentsTypes.TEXT,
            value: "<p style='text-align: center;'><span style='font-family: Montserrat; font-size: 20px; font-weight: 600; line-height: 1.5;'>" +
                "De l'architecture à la réalisation, jusqu'à la maintenance, nous maîtrisons " +
                "<span style='color: #0000FF'>toute la chaîne logicielle</span> d'un projet pour permettre de répondre au " +
                "<span style='color: #0000FF'>challenge de demain</span>.</span></p>",
        },
        {
            key: "titleNumbersPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "DOCAPOSTE AGILITY EN CHIFFRES",
        },
        {
            key: "subtitleNumbersPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Notre expertise en quelques chiffres",
        },
        {
            key: "horizontalInfos",
            type: contentsCustomTypesEnum.HORIZONTAL_INFOS,
            value: "",
            children: [
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: contentsCustomTypesEnum.HORIZONTAL_INFO_ITEM,
                            children: [
                                createHorizontalInfoItem("200 000+", "connexions en pic par jour", "Nos plateformes d’authentification absorbent les pics de charges sans rupture de service"),
                                createHorizontalInfoItem("100+", "projets réalisés", "Nos plateformes d’authentification absorbent les pics de charges sans rupture de service"),
                                createHorizontalInfoItem("50+", "collaborateurs experts", "Nos plateformes d’authentification absorbent les pics de charges sans rupture de service"),
                                createHorizontalInfoItem("10+", "années d’expérience", "Nos plateformes d’authentification absorbent les pics de charges sans rupture de service"),
                                createHorizontalInfoItem("100+", "machines physiques", "Nos plateformes d’authentification absorbent les pics de charges sans rupture de service"),
                                createHorizontalInfoItem("800+", "machines virtuelle", "Nos plateformes d’authentification absorbent les pics de charges sans rupture de service"),
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "cardsGrid",
            type: contentsCustomTypesEnum.CARDS_GRID,
            value: "",
            children: [
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: contentsCustomTypesEnum.CARDS_GRID_ITEM,
                            children: [
                                createCardGridItem("Nos services", "Des compétences multiples, une seule équipe", "Du cadrage à l'exploitation en production, une équipe unique.", {
                                    title: "Voir tous nos services",
                                    url: "/services",
                                }),
                                createCardGridItem("", "Développement web", "Applications web sur mesure, performantes et durables.", {
                                    title: "Voir",
                                    url: "/developpement-web",
                                }, "laptop"),
                                createCardGridItem("", "Développement mobile", "iOS, Android et cross-plateforme.", {
                                    title: "Voir",
                                    url: "/developpement-mobile",
                                }, "mobile"),
                                createCardGridItem("", "Keycloak / IAM", "Identités, SSO et sécurité des accès.", {
                                    title: "Voir",
                                    url: "/keycloak",
                                }, "user-shield"),
                                createCardGridItem("", "DevOps & Cloud", "Intégration et déploiement continus, infrastructure maîtrisée.", {
                                    title: "Voir",
                                    url: "/devops-cloud",
                                }, "cloud"),
                                createCardGridItem("", "Design UX / UI", "Parcours pensés pour l'usage, interfaces soignées.", {
                                    title: "Voir",
                                    url: "/design-ux-ui",
                                }, "palette"),
                                createCardGridItem("", "Maintenance & Run", "Intégration et déploiement continus, infrastructure maîtrisée.", {
                                    title: "Voir",
                                    url: "/maintenance-run",
                                }, "cogs"),
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titleTechPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "EXPERTISES",
        },
        {
            key: "subtitleTechPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Notre écosystème technique",
        },
        {
            key: "autoScrollingInfoPart",
            type: contentsCustomTypesEnum.AUTO_SCROLLING_INFOS,
            value: "",
            children: [
                {
                    key: "nbRow",
                    type: ContentsTypes.INPUT_NUMBER,
                    value: "2",
                },
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: contentsCustomTypesEnum.AUTO_SCROLLING_INFO_ITEM,
                            children: [
                                createAutoScrollingInfoItem("NodeJS"),
                                createAutoScrollingInfoItem("React"),
                                createAutoScrollingInfoItem("Typescript"),
                                createAutoScrollingInfoItem("Keycloak"),
                                createAutoScrollingInfoItem("Java"),
                                createAutoScrollingInfoItem("Spring Boot"),
                                createAutoScrollingInfoItem("NestJs"),
                                createAutoScrollingInfoItem("Vault"),
                                createAutoScrollingInfoItem("Teleport"),
                                createAutoScrollingInfoItem("Crowdsec"),
                                createAutoScrollingInfoItem("Grafana"),
                                createAutoScrollingInfoItem("Promethus"),
                                createAutoScrollingInfoItem("Docker"),
                                createAutoScrollingInfoItem("Kubernetes"),
                                createAutoScrollingInfoItem("React Native"),
                                createAutoScrollingInfoItem("Elastic"),
                                createAutoScrollingInfoItem("SElastic"),
                                createAutoScrollingInfoItem("Gitlab"),
                                createAutoScrollingInfoItem("Sonar"),
                                createAutoScrollingInfoItem("Nexus"),
                                createAutoScrollingInfoItem("Gatling"),
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "dynamicNumbersPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
        },
        {
            key: "titleProductsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "NOS SOLUTIONS",
        },
        {
            key: "subtitleProductsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Nous concevons aussi nos propres produits",
        },
        {
            key: "dynamicProductPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
        },
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
        },
    ],
};
